/**
 * Resolve a deep-link route for a notification row.
 */
export const getNotificationRoute = (notification) => {
  const action = notification?.notification_action;
  const type = notification?.notification_type;
  const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false");
  const isReportingManager = JSON.parse(sessionStorage.getItem("reportingManager") || "false");

  if (action === "attendance_log") return "/attendance/attendancelog";
  if (action === "punch_discrepancies") return "/attendance/punch-discrepancies";
  if (action === "dashboard") return "/home";
  if (action === "view_training") return "/training";

  const employeeRoutes = {
    Leave: "/employee/leaverequest",
    Reimbursement: "/employee/reimbursementrequest",
    Advance: "/employee/advancerequest",
    Overtime: "/employee/overtimerequest",
    Resignation: "/employee/resignationrequest",
    Timesheet: "/employee/timesheet",
    Asset: "/assetmanagement/assetrequest",
  };

  const approvalActions = new Set(["request"]);
  const employeeActions = new Set(["approved", "rejected", "cancelled", "processed"]);

  if (type === "Timesheet" && approvalActions.has(action) && (isAdmin || isReportingManager)) {
    return "/employee/team/timesheet";
  }

  if (approvalActions.has(action) && (isAdmin || isReportingManager)) {
    return "/employee/approvalinbox";
  }

  if (employeeActions.has(action) && employeeRoutes[type]) {
    return employeeRoutes[type];
  }

  if (type === "Appraisal Assigned" || type === "Appraisal Published") {
    return "/appraisal/my-appraisal";
  }

  if (type === "Training Assigned" || type === "Training Overdue") {
    return "/training";
  }

  if (type === "Transfer Reporting Manager") {
    return "/employeeprofile";
  }

  if (type === "AttendanceException" || type === "AttendanceExceptionManager") {
    return "/attendance/attendancelog";
  }

  if (type === "AttendanceDiscrepancy") {
    return "/attendance/punch-discrepancies";
  }

  if (type === "System") {
    return "/home";
  }

  if (type === "Payroll") {
    return "/payroll/payslips";
  }

  if (type === "BirthdayAlert") {
    return "/home";
  }

  if (type === "Exit") {
    return "/employee/resignationrequest/process";
  }

  if (approvalActions.has(action)) {
    return "/employee/approvalinbox";
  }

  return null;
};
